import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown_button = _resolveComponent("a-dropdown-button")!

  return (!_ctx.user.isLogin)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/login"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            shape: "round",
            class: "user-profile-component"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 登录 ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_dropdown_button, { class: "user-profile-component" }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, { class: "user-profile-dropdown" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "0",
                  onClick: _ctx.goUserSetting
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 个人设置 ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_menu_item, {
                  key: "2",
                  onClick: _ctx.logout
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 登出 ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/setting" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.user.data.nickName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
}